import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../../extension/interface/benefit-metadata.extension.interface';

export class CustomBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Custom;
  get Icon(): React.ComponentType<SvgIconProps> {
    return DashboardCustomizeIcon;
  }
}
